import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

import { hideModal, showModal, useModal } from 'zustand-stores/modalStore';

export function useVMOnboardingModalsExperiment() {
  const location = useLocation();
  const { modal } = useModal();
  const currentModalType = modal?.type;
  const [hasShownModal, setHasShownModal] = useState(false);

  const shouldShow = useMemo(() => {
    if (hasShownModal) return false;
    const searchParams = new URLSearchParams(location.search);
    return searchParams.has('show-vm-onboarding');
  }, [hasShownModal, location.search]);

  useEffect(() => {
    const noModalPresent = !currentModalType;

    if (shouldShow && noModalPresent) {
      showModal('VM_ONBOARDING_DEBUG', {
        onClose: () => {
          hideModal();
          setHasShownModal(true);
        },
      });
      return;
    }

    if (!shouldShow && currentModalType === 'VM_ONBOARDING_DEBUG') {
      hideModal();
    }
  }, [shouldShow, currentModalType]);
}
